import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface PaymentStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  paymentMethod: string;
  totalPrice: number;
}

const PaymentStatusModal: React.FC<PaymentStatusModalProps> = ({
  isOpen,
  onClose,
  paymentMethod,
  totalPrice,
}) => {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(price);
  };

  const getPaymentMethodName = (method: string) => {
    switch (method) {
      case "qris":
        return "QRIS";
      case "dana":
        return "DANA";
      case "shopeepay":
        return "Shopee Pay";
      default:
        return method;
    }
  };

  const renderPaymentContent = () => {
    switch (paymentMethod) {
      case "dana":
      case "shopeepay":
        return (
          <div className="text-center space-y-4">
            <div className="bg-green-100 p-6 rounded-lg">
              <div className="w-16 h-16 bg-green-400 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">✓</span>
              </div>
              <h3 className="text-lg font-semibold text-green-800">
                Payment Processing
              </h3>
              <p className="text-sm text-green-600">
                Your payment is being processed.
              </p>
            </div>
            <p className="text-sm text-muted-foreground">
              Please check your WhatsApp / Email app to complete the payment.
            </p>
          </div>
        );

      case "qris":
        return (
          <div className="text-center space-y-4">
            <div className="bg-white p-4 rounded-lg border-2 border-dashed mx-auto w-48 h-48 flex items-center justify-center">
              <div className="text-center">
                <div className="w-32 h-32 bg-gray-200 rounded flex items-center justify-center mx-auto mb-2">
                  <span className="text-sm text-gray-500">QR Code</span>
                </div>
                <p className="text-xs text-muted-foreground">
                  Scan this QR code to pay
                </p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              Please scan the QR code using your mobile banking app to complete
              the payment.
            </p>
          </div>
        );

      default:
        return (
          <div className="text-center">
            <p className="text-muted-foreground">
              Payment method not recognized.
            </p>
          </div>
        );
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Payment - Clip Purchases</DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          {/* Payment Amount */}
          <div className="text-center">
            <p className="text-sm text-muted-foreground">Amount to pay</p>
            <p className="text-2xl font-bold text-primary">
              {formatPrice(totalPrice)}
            </p>
          </div>

          {/* Payment Content */}
          {/* {renderPaymentContent()} */}
          <div className="text-center space-y-4">
            <p className="text-sm text-muted-foreground">
              Please check your WhatsApp / Email app to complete the payment.
            </p>
          </div>

          {/* Action Button */}
          <Button onClick={onClose} className="w-full">
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentStatusModal;
